/* eslint-disable react/forbid-prop-types */
import PropTypes from 'prop-types';

const intlShape = PropTypes.shape({
  locale: PropTypes.string,
  timeZone: PropTypes.string,
  formats: PropTypes.object,
  messages: PropTypes.object,
  textComponent: PropTypes.any,
  defaultLocale: PropTypes.string,
  defaultFormats: PropTypes.object,
  onError: PropTypes.func,
  formatDate: PropTypes.func.isRequired,
  formatTime: PropTypes.func.isRequired,
  formatNumber: PropTypes.func.isRequired,
  formatPlural: PropTypes.func.isRequired,
  formatMessage: PropTypes.func.isRequired,
  formatters: PropTypes.object,
});

export { intlShape };
export default intlShape;
